import React, { useState, useMemo, useRef, useCallback } from "react";
import { useSelector } from "react-redux";
import { Swiper } from "antd-mobile";
import PeiChart from "@containers/facility/Overview/PieChart";
import "./SwitchablePieChart.css";

const SwitchablePieChart = ({ configs = [], defaultActiveKey }) => {
  const [activeKey, setActiveKey] = useState(
    defaultActiveKey || configs[0]?.key
  );
  const view = useSelector((state) => state.App.view);
  const isMobile = view === "MobileView";

  const activeIndex = useMemo(
    () => configs.findIndex((c) => c.key === activeKey),
    [configs, activeKey]
  );

  const swiperRef = useRef(null);

  const handleIndicatorChange = useCallback((val) => {
    setActiveKey(val);
    const idx = configs.findIndex((c) => c.key === val);
    if (swiperRef.current && idx >= 0) {
      swiperRef.current.swipeTo(idx);
    }
  }, [configs]);

  const handleSwiperChange = useCallback((idx) => {
    const config = configs[idx];
    if (config) {
      setActiveKey(config.key);
    }
  }, [configs]);

  const renderIndicator = () => (
    <div className="switchable-pie-header">
      <div className="switchable-pie-dots" aria-label="Chart carousel indicator">
        {configs.map((config, index) => (
          <button
            key={config.key}
            type="button"
            className={`switchable-pie-dot${index === activeIndex ? " active" : ""}`}
            aria-label={`Show ${config.label}`}
            aria-current={index === activeIndex ? "true" : undefined}
            title={config.label}
            onClick={() => handleIndicatorChange(config.key)}
          />
        ))}
      </div>
    </div>
  );

  const renderChart = (config) => {
    if (config.render) {
      return config.render();
    }

    return (
      <PeiChart
        data={config.data}
        height={200}
        colors={config.colors}
        title={config.title}
        handleChartClick={config.onClick}
      />
    );
  };

  const renderSwiper = () => (
    <div className="switchable-pie-swiper-wrap">
      <Swiper
        ref={swiperRef}
        loop={false}
        className="switchable-pie-swiper"
        defaultIndex={activeIndex >= 0 ? activeIndex : 0}
        onIndexChange={handleSwiperChange}
        indicator={false}
      >
        {configs.map((config) => (
          <Swiper.Item key={config.key}>
            <div className="switchable-pie-swiper-item">
              {renderChart(config)}
            </div>
          </Swiper.Item>
        ))}
      </Swiper>
    </div>
  );

  if (!configs.length) {
    return null;
  }

  return (
    <div className={isMobile ? "switchable-pie-mobile" : "switchable-pie-wrapper"}>
      {renderIndicator()}
      {renderSwiper()}
    </div>
  );
};

export default SwitchablePieChart;
